(function () {
  'use strict';

  document.documentElement.classList.add('estilo-motion-ready');

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------
     Reveal on scroll (IntersectionObserver) + staggered children
     --------------------------------------------------------------- */
  function initReveal() {
    if (prefersReduced) {
      document.querySelectorAll('.estilo-reveal').forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.1 }
    );

    document.querySelectorAll('.estilo-reveal').forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ---------------------------------------------------------------
     Size guide toggle
     --------------------------------------------------------------- */
  function initSizeGuide() {
    document.querySelectorAll('[data-estilo-size-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (!panel) return;
        var open = panel.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------------------------------------------------------------
     Magnetic hover on primary buttons (rAF, no layout thrash)
     --------------------------------------------------------------- */
  function initMagneticButtons() {
    if (prefersReduced) return;
    var buttons = document.querySelectorAll('.estilo-btn--primary, .estilo-page-hero__actions .estilo-btn');

    buttons.forEach(function (btn) {
      var raf = null;
      btn.style.willChange = 'transform';

      btn.addEventListener('pointermove', function (e) {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var rect = btn.getBoundingClientRect();
          var x = e.clientX - (rect.left + rect.width / 2);
          var y = e.clientY - (rect.top + rect.height / 2);
          var strength = 0.22;
          btn.style.transform = 'translate(' + x * strength + 'px, ' + y * strength + 'px)';
        });
      });

      btn.addEventListener('pointerleave', function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          btn.style.transform = 'translate(0, 0)';
        });
      });
    });
  }

  /* ---------------------------------------------------------------
     Storefront card tilt-lite on hover
     --------------------------------------------------------------- */
  function initCardHover() {
    if (prefersReduced) return;
    var cards = document.querySelectorAll(
      '.estilo-collection-card, .estilo-drop-card, .estilo-trust__item, ' +
      '.template-collection .product-card-wrapper, .template-search .product-card-wrapper, ' +
      '.template-product .related-products .product-card-wrapper'
    );

    cards.forEach(function (card) {
      var raf = null;
      card.addEventListener('pointermove', function (e) {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var rect = card.getBoundingClientRect();
          var x = (e.clientX - rect.left) / rect.width - 0.5;
          var y = (e.clientY - rect.top) / rect.height - 0.5;
          card.style.transform = 'perspective(1000px) translateY(-3px) rotateY(' + x * 3.5 + 'deg) rotateX(' + y * -3.5 + 'deg)';
        });
      });

      card.addEventListener('pointerleave', function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          card.style.transform = '';
        });
      });
    });
  }

  function init() {
    initReveal();
    initSizeGuide();
    initMagneticButtons();
    initCardHover();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
